@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="taxes()"
    [label]="'entity.taxes' | translate"
    textField="name"
  />
} @else {
  <elcia-dropdown
    [control]="control()"
    [items]="taxes()"
    [label]="'entity.tax' | translate"
    textField="name"
  />
}
